export default __webpack_public_path__ + "static/media/services_food.3755c483.svg";